<template>
  <div class="questionnaire-inquiry v-hoverable" @click="handleClick">
    <el-image
      style="width: 14px; height: 14px"
      src="https://imagecdn.ymm56.com/ymmfile/static/resource/92c195f2-c55e-4683-a0e2-0a846386dbdc.png"
      fit="fit"
    ></el-image>
    <span>问卷调研</span>
  </div>
</template>

<script setup>
import DrawerIframe from '@/components/DrawerIframe.vue'
import { getCurrentInstance, defineProps } from 'vue'
const props = defineProps(['customerId'])
const instance = getCurrentInstance().proxy
const handleClick = () => {
  const userId = props.customerId
  instance
    .$createDrawer(
      DrawerIframe,
      {
        customerStyle: 'min-width:375px',
        url: `https://static.ymm56.com/microweb/vue.html#/mw-tview/index?key=e2dd172&userId=${userId}`
      },
      {
        title: '问卷调研',
        size: '375px',
        withHeader: false
      }
    )
    .show()
}
</script>

<style lang="stylus" scoped>
.questionnaire-inquiry {
  display: flex;
  align-items: center;
  gap :4px;
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  letter-spacing: 0px;
  color: #424F6B
}
</style>
